import { getAllowedStorageKeys as defaultGetAllowedStorageKeys } from '../../store/_core/getAllowedStorageKeys';
import { StorageGuardParams } from './types/StorageGuardParams';

const StorageGuard = ({
  children,
  getAllowedStorageKeys = defaultGetAllowedStorageKeys,
}: StorageGuardParams): JSX.Element => {
  const allowedStorageKeys = getAllowedStorageKeys();

  // Remove any localStorage keys that are not registered by the persist middleware.
  // This ensures the removal of stale or legacy keys from localStorage so that we can
  // maintain a clean and up-to-date storage environment.
  for (const key of Object.keys(localStorage)) {
    if (!allowedStorageKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  }

  return children;
};

export default StorageGuard;
